import React from 'react';
import ServicePageTemplate from '../../../../components/ServicePageTemplate/ServicePageTemplate';

const CategoryPageFactory = ({ 
  categoryConfig, 
  services = [], 
  isLoading = false,
  onBookNow,
  onLearnMore 
}) => {
  if (!categoryConfig) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">
            Category Not Found
          </h2>
          <p className="text-gray-600">
            The requested service category could not be found.
          </p>
        </div>
      </div>
    );
  }

  // Generate page configuration from category config
  const pageConfig = {
    title: categoryConfig.displayName,
    description: categoryConfig.description,
    breadcrumbs: [
      { label: 'Home', path: '/' },
      { label: 'Services', path: '/services' },
      { label: categoryConfig.displayName, path: `/services/categories/${categoryConfig.name}` }
    ],
    hero: {
      title: categoryConfig.displayName,
      subtitle: categoryConfig.description,
      backgroundImage: categoryConfig.image,
      primaryColor: categoryConfig.getCustomization('primaryColor'),
      secondaryColor: categoryConfig.getCustomization('secondaryColor')
    },
    filters: {
      enabled: categoryConfig.getCustomization('showAdvancedFilters'),
      priceComparison: categoryConfig.getCustomization('enablePriceComparison')
    },
    features: {
      reviews: categoryConfig.getCustomization('showReviews'),
      instantBooking: categoryConfig.hasFeature('INSTANT_BOOKING'),
      liveStreaming: categoryConfig.hasFeature('LIVE_STREAMING'),
      customization: categoryConfig.hasFeature('CUSTOMIZATION'),
      consultation: categoryConfig.hasFeature('CONSULTATION'),
      documentation: categoryConfig.hasFeature('DOCUMENTATION')
    },
    theme: categoryConfig.getCustomization('theme')
  };

  // Custom styling based on category theme
  const getThemeStyles = () => {
    const theme = categoryConfig.getCustomization('theme');
    const primaryColor = categoryConfig.getCustomization('primaryColor');
    const secondaryColor = categoryConfig.getCustomization('secondaryColor');

    return {
      '--category-primary': primaryColor,
      '--category-secondary': secondaryColor,
      '--category-theme': theme
    };
  };

  return (
    <div 
      className={`category-page category-page--${categoryConfig.getCustomization('theme')}`}
      style={getThemeStyles()}
    >
      <ServicePageTemplate
        title={pageConfig.title}
        description={pageConfig.description}
        services={services}
        isLoading={isLoading}
        onBookNow={onBookNow}
        onLearnMore={onLearnMore}
        pageConfig={pageConfig}
        categoryConfig={categoryConfig}
      />
    </div>
  );
};

export default CategoryPageFactory;
